const initAuthorSort = () => {
    document.querySelectorAll('[data-dropdown]').forEach(dropdown => {
        const dropdownBtn = dropdown.querySelector('[data-btn]');
        const dropdownContent = dropdown.querySelector('[data-content]');
        const selectedText = dropdown.querySelector('[data-selected]');
        const hiddenInput = dropdown.querySelector('input[type="hidden"]');
        const form = dropdown.closest('form');

        if (!dropdownBtn || !dropdownContent || !form || !hiddenInput || !selectedText) return;

        const urlParams = new URLSearchParams(window.location.search);
        const currentValue = urlParams.get(hiddenInput.name);

        // Устанавливаем текст при загрузке
        if (currentValue) {
            const selectedElement = dropdownContent.querySelector(`[data-value="${currentValue}"]`);
            if (selectedElement) {
                selectedText.textContent = selectedElement.textContent;
            }
        }

        // Открыть/закрыть дропдаун
        dropdownBtn.addEventListener('click', (e) => {
            e.preventDefault();
            dropdownContent.classList.toggle('show');
            dropdown.classList.toggle('open');
        });

        // Клик по элементу
        dropdownContent.addEventListener('click', (e) => {
            const element = e.target.closest('[data-value]');
            if (!element) return;

            selectedText.textContent = element.textContent;

            if (element.dataset.value === '') {
                hiddenInput.removeAttribute('name'); // для All
            } else {
                hiddenInput.setAttribute('name', hiddenInput.dataset.name);
                hiddenInput.value = element.dataset.value;
            }

            dropdownContent.classList.remove('show');
            dropdown.classList.remove('open');
            form.submit();
        });

        // Клик вне → закрыть
        document.addEventListener('click', (e) => {
            if (!dropdown.contains(e.target)) {
                dropdownContent.classList.remove('show');
                dropdown.classList.remove('open');
            }
        });
    });

    // --- сортировка (работает везде одинаково) ---
    const forms = document.querySelectorAll('form.po-filter-form');
    forms.forEach(form => {
        form.querySelectorAll('.po-radio-btn__input').forEach(radio => {
            radio.addEventListener('change', function () {
                const urlParams = new URLSearchParams(window.location.search);
                if (this.value === 'desc' && !urlParams.has('order')) {
                    urlParams.delete('order');
                    window.history.replaceState({}, document.title, window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : ''));
                }
                form.submit();
            });
        });
    });
};

export { initAuthorSort };
